import { ACTION_TYPES } from '../asset-bar/constants';
export const ACTION_ICONS_MAP = {
  [ACTION_TYPES.download]: 'action_download_stroke',
  [ACTION_TYPES.redirect]: 'action_new_window',
};
